import { FC } from 'react'
import { BodyLarge } from './styles/Typography'
import { env } from '../utils/environments/environmentVariables'
import { useTranslation } from 'react-i18next'

type ErrorGuardProps = {
  error?: Error | null
}

export const ErrorGuard: FC<ErrorGuardProps> = ({ error }) => {
  const { t } = useTranslation()

  // Determine the appropriate error message
  // Detect network blocked error (TypeError with "Failed to fetch")
  const isNetworkBlocked = error instanceof TypeError && 'message' in error && error.message === 'Failed to fetch'
  const errorMessage = isNetworkBlocked ? t('common.errors.networkBlocked') : t('common.errors.somethingWentWrong')

  if (env.isProd('VITE_NODE_ENV')) {
    const errorToLog = error || new Error(`Failed to fetch data at ${window.location.href}`)
    // eslint-disable-next-line no-console
    console.error(errorToLog)
    return <BodyLarge>{errorMessage}</BodyLarge>
  } else {
    // eslint-disable-next-line no-console
    console.log('Failed to fetch data', error)
    return <BodyLarge>{errorMessage}</BodyLarge>
  }
}
